import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_CONFIG, fetchWithTimeout } from "../config/api";
import { useAuth } from "../hooks/useAuth";
import "../styles/Login.css";

const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth();

  const [formData, setFormData] = useState({
    ra: "",
    password: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    try {
      const requestBody = {
        login: {
          ra: formData.ra,
          password: formData.password,
        },
      };

      // Enviar requisição para a API
      const response = await fetchWithTimeout(API_CONFIG.LOGIN_URL, {
        method: "POST",
        headers: API_CONFIG.DEFAULT_HEADERS,
        body: JSON.stringify(requestBody),
      });

      const data = await response.json();
      if (data.ok && data.token) {
        console.log("Login bem-sucedido:", data);

        // Usar o hook de autenticação para armazenar o token
        if (data.token) {
          login(data.token, data.user);
          console.log("Token armazenado com sucesso");
        }

        navigate("/dashboard");
      } else {
        setError(data.message || "Erro no login. Tente novamente.");
        console.error("Erro no login:", data);
      }
    } catch (error) {
      console.log(error);
      console.error("Erro ao conectar com a API:", error);
      setError("Erro de conexão. Verifique sua internet e tente novamente.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleBackToHome = () => {
    navigate("/");
  };

  return (
    <div className="login-container">
      <div className="box-header">
        <button className="back-button" onClick={handleBackToHome}>
          <img
            alt=""
            src="/images/login/svg/arrow_back.svg"
            fill="currentColor"
            className="icon"
          />
          <span className="button-text">Voltar</span>
        </button>
        <div className="uniguacu-logo">
          <img alt="Uniguaçu" src="/images/login/logo-faculdade.png" />
        </div>
      </div>

      <div className="login-card">
        <div className="card-header">
          <img
            alt="Amigo Indica Amigo"
            src="/images/login/logo-aia.svg"
            className="aia-logo"
          />
          <p className="text-conta">
            Sua conta no Amigo Indica Amigo é a mesma do painel de estudante do
            JACAD, basta logar com o mesmo e-mail e senha
          </p>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <div className="input-container">
              <label className="field-label" htmlFor="ra">
                <img
                  alt=""
                  src="/images/login/svg/backpack.svg"
                  fill="currentColor"
                  className="icon"
                />
                <span className="label-text">EMAIL/RA/CPF</span>
              </label>
              <input
                type="text"
                name="ra"
                id="ra"
                value={formData.ra}
                onChange={handleInputChange}
                placeholder="Digite aqui..."
                required
              />
            </div>
          </div>

          <div className="form-group">
            <div className="input-container">
              <label className="field-label" htmlFor="password">
                <img
                  alt=""
                  src="/images/login/svg/lock.svg"
                  fill="currentColor"
                  className="icon"
                />
                <span className="label-text">SENHA</span>
              </label>
              <div className="box-input-icon">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  id="password"
                  value={formData.password}
                  onChange={handleInputChange}
                  placeholder="Digite sua senha"
                  required
                />
                <button
                  type="button"
                  className="password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    // Show password (svg direto no código para possibilitar a mudança de cor no hover)
                    <svg
                      width="19"
                      height="17"
                      viewBox="0 0 19 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9.16667 13.5C7.06944 13.5 5.20139 12.9201 3.5625 11.7604C1.92361 10.6007 0.736111 9.09722 0 7.25C0.736111 5.40278 1.92361 3.89931 3.5625 2.73958C5.20139 1.57986 7.06944 1 9.16667 1C11.2639 1 13.1319 1.57986 14.7708 2.73958C16.4097 3.89931 17.5972 5.40278 18.3333 7.25C17.5972 9.09722 16.4097 10.6007 14.7708 11.7604C13.1319 12.9201 11.2639 13.5 9.16667 13.5ZM9.16667 11C10.2083 11 11.0938 10.6354 11.8229 9.90625C12.5521 9.17708 12.9167 8.29167 12.9167 7.25C12.9167 6.20833 12.5521 5.32292 11.8229 4.59375C11.0938 3.86458 10.2083 3.5 9.16667 3.5C8.125 3.5 7.23958 3.86458 6.51042 4.59375C5.78125 5.32292 5.41667 6.20833 5.41667 7.25C5.41667 8.29167 5.78125 9.17708 6.51042 9.90625C7.23958 10.6354 8.125 11 9.16667 11Z"
                        fill="currentColor"
                      />
                    </svg>
                  ) : (
                    // Hide password icon
                    <svg
                      width="19"
                      height="17"
                      viewBox="0 0 19 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.6667 16.5L12.1667 13.0417C11.6806 13.1944 11.191 13.309 10.6979 13.3854C10.2049 13.4618 9.69444 13.5 9.16667 13.5C7.06944 13.5 5.20139 12.9201 3.5625 11.7604C1.92361 10.6007 0.736111 9.09722 0 7.25C0.291667 6.51389 0.659722 5.82986 1.10417 5.19792C1.54861 4.56597 2.05556 4 2.625 3.5L0.333333 1.16667L1.5 0L16.8333 15.3333L15.6667 16.5ZM9.16667 11C9.31944 11 9.46181 10.9931 9.59375 10.9792C9.72569 10.9653 9.86806 10.9375 10.0208 10.8958L5.52083 6.39583C5.47917 6.54861 5.45139 6.69097 5.4375 6.82292C5.42361 6.95486 5.41667 7.09722 5.41667 7.25C5.41667 8.29167 5.78125 9.17708 6.51042 9.90625C7.23958 10.6354 8.125 11 9.16667 11ZM15.25 11.375L12.6042 8.75C12.7014 8.51389 12.7778 8.27431 12.8333 8.03125C12.8889 7.78819 12.9167 7.52778 12.9167 7.25C12.9167 6.20833 12.5521 5.32292 11.8229 4.59375C11.0938 3.86458 10.2083 3.5 9.16667 3.5C8.88889 3.5 8.62847 3.52778 8.38542 3.58333C8.14236 3.63889 7.90278 3.72222 7.66667 3.83333L5.54167 1.70833C6.11111 1.47222 6.69444 1.29514 7.29167 1.17708C7.88889 1.05903 8.51389 1 9.16667 1C11.2639 1 13.1319 1.57986 14.7708 2.73958C16.4097 3.89931 17.5972 5.40278 18.3333 7.25C18.0139 8.06944 17.5938 8.82986 17.0729 9.53125C16.5521 10.2326 15.9444 10.8472 15.25 11.375ZM11.3958 7.54167L8.89583 5.04167C9.28472 4.97222 9.64236 5.00347 9.96875 5.13542C10.2951 5.26736 10.5764 5.45833 10.8125 5.70833C11.0486 5.95833 11.2188 6.24653 11.3229 6.57292C11.4271 6.89931 11.4514 7.22222 11.3958 7.54167Z"
                        fill="currentColor"
                      />
                    </svg>
                  )}
                </button>
              </div>
            </div>
          </div>

          <div className="login-options">
            <label className="remember-me" htmlFor="remember-me">
              <input
                type="checkbox"
                id="remember-me"
                name="remember-me"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
                className="remember-checkbox"
              />
              <span class="slider"></span>
            </label>
            <span className="remember-text">Manter-me conectado</span>
          </div>

          {error && <div className="error-message">{error}</div>}

          <button type="submit" className="login-button" disabled={isLoading}>
            {isLoading ? "Entrando..." : "Entrar"}
          </button>

          {/* <div className='box-login-conta'>
            <span>Já tem uma conta?</span>
            <a href="#esqueci-senha" className="forgot-password">
              Clique aqui e faça login
            </a>
          </div> */}
        </form>
      </div>

      <div className="copyright">
        Copyright © 2025. Todos os direitos reservados. Faculdade Uniguaçu.
        CNPJ: 03.097.823/0001-75
      </div>
    </div>
  );
};

export default Login;
